import { axiosInstance } from '@/plugins/axios';

export default {
	namespaced: true,
	state: {
    premiumResources: [],
		premiumPlans: [],
	},
	getters: {
    premiumResources(state) {
			return state.premiumResources;
		},
		premiumPlans(state) {
			return state.premiumPlans;
		},
	},
	mutations: {
    SET_PREMIUM_RESOURCES(state, value) {
			state.premiumResources = value;
		},
		SET_PREMIUM_PLANS(state, value) {
			state.premiumPlans = value;
		},
	},
	actions: {
    async registerPremiumResources(context, value) {
      let formData = new FormData();
      formData.append('id_user', value.id_user);
      formData.append('text', value.resources);

      const url = value.id ? `premium/resources/${value.id}` : 'premium/resources';

      await axiosInstance({
        method: 'POST',
        url: url,
        data: formData
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultPlansPremium');
        })
    },
    async registerPremium(context, value) {
      let formData = new FormData();
      formData.append('id_user', value.id_user);
      formData.append('name', value.name);
      formData.append('price', value.price);
      formData.append('description', value.description);

      const url = value.id ? `premium/${value.id}` : 'premium';

      await axiosInstance({
        method: 'POST',
        url: url,
        data: formData
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultPlansPremium');
        })
    },
    async consultPlansPremium(context){
      await axiosInstance({
        method: 'GET',
        url: 'premium',
      }).then(response => response.data)
        .then(resp => {
          context.dispatch('setDataDefault', ['SET_PREMIUM_RESOURCES', resp.resources]);
          context.dispatch('setDataDefault', ['SET_PREMIUM_PLANS', resp.data]);
        })
    },
    async removePremiumResources(context, id){
      await axiosInstance({
        method: 'DELETE',
        url: `premium/resources/${id}`,
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultPlansPremium');
        })
    },
    async removePremium(context, id){
      await axiosInstance({
        method: 'DELETE',
        url: `premium/${id}`,
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultPlansPremium');
        })
    },
    setDataDefault(context, [mutationName, value]){
      context.commit(`${mutationName}`, value);
    },
	}
}
